@let type = $type();
@let disabled = $disabled() !== undefined ? $disabled() : $controlDisabled();
@let controlPosition = $controlPosition();
@let placeholder = $placeholder();
@let verticalAlignment = $verticalAlignment() === 'center' ? 'items-center' : $verticalAlignment() === 'start' ? 'items-start' : 'items-end';
<label
  [class]="'px-1 flex w-full' + (controlPosition === 'default' || controlPosition === 'opposite' ? ' items-center' : ' flex-col ' + verticalAlignment)"
  [style.padding]="$innerPadding()"
  [style.gap]="$gap() | cssValue"
  [class.disab]="disabled"
  [class.readonly]="$readonly()"
  [matTooltip]="!disabled ? $tooltip() : $tooltipWhenDisabled()"
>
  @if ($label() !== null) {
  <p
    [class]="($readonly() ? '' : 'select-none') + ($labelWrap() ? '' : ' whitespace-nowrap') + (controlPosition === 'opposite' || controlPosition === 'top' ? ' order-1' : '')"
    [style.fontSize]="$labelFontSize() | cssValue"
    [style.fontWeight]="$labelWeight()"
    [style.color]="'var(' + $labelColor() + ')'"
  >{{ $label() }}</p>
  }
  <span class="inline-block relative w-full">
    <div class="grid items-center">
      <input
        #input
        class="input"
        [step]="!$seconds() ? '0' : '1'"
        [type]="type"
        [value]="$stringValue()"
        [min]="$min()"
        [max]="$max()"
        [disabled]="disabled || $readonly()"
        [style.width]="$inputWidth()"
        [style.fontSize]="$inputFontSize() | cssValue"
        [style.paddingRight]="type === 'date' ? '' : (!disabled && !$readonly() ? '9px' : '29px')"
        (input)="onValueChange($event)"
      >
      @if (type !== 'datetime-local') {
      <span class="value">
        <p
          class="select-none whitespace-nowrap"
          [style.fontSize]="$inputFontSize() | cssValue"
          [class.placeholder-text]="placeholder !== null"
        >{{ placeholder !== null ? placeholder : $displayValue() }}</p>
      </span>
      }
    </div>

    <span class="side-icon">
      <app-icon
        icon="calendar-text-outline"
        size="19px 20px"
      />
    </span>
  </span>
</label>
